<template>
  <div class="head clearfix">
    <div class="content clearfix">
      <div class="logo fl">
        <router-link to="/">
          <!--<svg-icon icon-class="logo"></svg-icon>-->
          <!-- <img style="width: 200px;" :src="require('@/basa/assets/images/protalLogo1.png')" /> -->
        </router-link>
      </div>
      <div class="search fl">
        <el-input class="search-input fl" v-model="name" :placeholder="$t('page.content.searchPlaceholder')"></el-input>
        <el-button type="text" class="search-btn fl" @click="search">{{
          $t("page.content.search")
        }}</el-button>
      </div>
      <div class="clearfix"></div>
      <div class="classes">
        <div :class="['all-classes fl', hoverClass]" ref="catalogInfo">
          {{ $t("page.content.all") }}
          <div class="catalog-info-hide">
            <div class="catalog-info">
              <ul class="cate-menu">
                <template v-for="(item, index) in catalogList">
                  <li :key="index" class="catalog-li">
                    <div style="position: relative;">
                      <img class="pr-5 catalog-img" :src="item.coverUrl" />
                      <div class="pl20 catalog-item ell">
                        <template v-for="(item1, index1) in item.children">
                          <el-link :key="index1" :underline="false" @click="handleClickCategory(item1)" class="mr5">{{
                            item1.categoryName }}</el-link>
                        </template>
                      </div>
                    </div>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" active-text-color="#0089EF">
          <template v-for="(item, index) in showFilter(brandList)">
            <el-menu-item :key="index">
              <router-link v-if="item.to" :to="item.to" :style="{ fontSize: fontSize ? '13px' : '16px' }">
                {{ item.name }}
              </router-link>
              <a @click="handleClick(item)" v-else :style="{ fontSize: fontSize ? '13px' : '16px' }">{{ item.name }}</a>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/config/store";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import { getMailAddress } from "../api/shopping";
import Cookies from "js-cookie";

export default {
  name: "shopHead",
  mixins: [mixinHomePage],
  data() {
    return {
      activeIndex: "0",
      brandList: [
        {
          name: this.$t("page.content.menu1"), //首页
          type: 1,
          to: "/",
          show: true
        },
        {
          name: this.$t("page.content.menu6"), //业务协同
          type: 6,
          show: !!Cookies.get("access_token")
        },
        // {
        //   name: this.$t("page.content.menu7"), //站内信
        //   type: 7,
        //   show: !!Cookies.get("access_token")
        // },
        // {
        //   name: this.$t("page.content.menu8"), //供应商信息变更
        //   type: 8,
        //   show: !!Cookies.get("access_token")
        // },
        // {
        //   name: this.$t("page.content.menu9"), //合作意向申请
        //   type: 9,
        //   show: !!Cookies.get("access_token")
        // },
        {
          name: this.$t("page.content.menu10"), //联系我们
          type: 10,
          show: true
        },

        // {
        //   name: this.$t("page.content.menu11"), //云租APP
        //   type: 11,
        //   show: true
        // }
        // {
        //   name: this.$t("page.content.menu4"), //供应商注册
        //   type: 4,
        //   show: true
        // }
        // {
        //   name: this.$t("page.content.menu2"), //集中采购
        //   type: 2
        // },
        // {
        //   name: this.$t("page.content.menu3"), //区域联采
        //   type: 3
        // },
        // {
        //   name: this.$t("page.content.menu4"), //供应商注册
        //   type: 4
        // },
        // {
        //   name: this.$t("page.content.menu5"), //供应链金融
        //   type: 5
        // }
        {
          name: this.$t("page.content.menu12"), //联系我们
          type: 12,
          show: !Cookies.get("access_token")
        },
      ],
      name: this.$route.query.name
    };
  },
  methods: {
    search() {
      this.$router.push({
        path: "/searchList",
        query: {
          name: this.name,
          v: Math.random()
        }
      });
    },
    showFilter(list) {
      let newList = list.filter(item => {
        return item.show === true;
      });
      return newList;
    },
    handleClick(item) {
      if (item.type === 4) {
        window.open(
          `${this.$addUrlPerFix(process.env.VUE_APP_SRA_URL)}/maReady01`
        );
      }
      if (item.type === 6) {

        // window.open(
        //   `${this.$addUrlPerFix(process.env.VUE_APP_BID_URL)}/?a=100121`
        // );
        let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
        let url = ''
        if (baseUrl.indexOf("dev01") != -1) {
          url = "https://dev01-" + process.env.VUE_APP_HWBID_URL;
        } else if (baseUrl.indexOf("test01") != -1) {
          url = "https://test01-" + process.env.VUE_APP_HWBID_URL;
        } else if (baseUrl.indexOf("uat01") != -1) {
          url = "https://uat01-" + process.env.VUE_APP_HWBID_URL;
        } else {
          url = "https://" + process.env.VUE_APP_HWBID_URL;
        }
        window.open(
          url + '/?a=162467'
        );
      }
      if (item.type === 7) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(`crma.iccec.cn${res.data.data.address}`)
            );
          }
        });
      }
      if (item.type === 8) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(
                `crma.iccec.cn/infoMaintain/infoChangeChangeList?a=${res.data.data.agentId}`
              )
            );
          }
        });
      }
      if (item.type === 9) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(
                `crma.iccec.cn/infoMaintain/cooperatorApplyCooperationApply?a=${res.data.data.agentId}`
              )
            );
          }
        });
      }
      if (item.type === 10) {
        let url = this.$router.resolve({
          path: "/contactUs",
          query: {}
        });
        window.open(url.href, "_blank");
      }
      if (item.type === 11) {
        let protocol = window.location.protocol;
        protocol +=
          "//oss-znlhzl.oss-cn-shanghai.aliyuncs.com/apk/prd/prd-hatch-zj/V1.0.1/app-release.apk";
        window.open(protocol);
      }

      if (item.type === 12) {
        this.$router.push({
          path: '/retrievePassword',
          query: {}
        })
      }
      // if (item.type === 4) {
      //   window.open(this.$addUrlPerFix("sra.iccec.cn/maReady01"));
      // }
    }
  },
  computed: {
    catalogList() {
      return store.state.user.catalogList;
    },
    fontSize() {
      return (
        !!Cookies.get("access_token") &&
        !('en-gb' === "zh-cn")
      );
    },
    hoverClass() {
      if (!store.state.user.isPortal) {
        return "catalog-info-hover";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input /deep/ input.el-input__inner {
  border: none !important;
}

.svg-icon {
  width: 100% !important;
  height: 68px !important;
}
</style>
